import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addHubBlogFailure,
  addHubBlogSuccess,
  deleteHubBlogFailure,
  deleteHubBlogSuccess,
  editHubBlogFailure,
  editHubBlogSuccess,
  fetchHubBlogFailure,
  fetchHubBlogSuccess,
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  uploadMediaFailure,
  uploadMediaSuccess,
} from "./actions";
import {
  ADD_HUBBLOG,
  DELETE_HUBBLOG,
  EDIT_HUBBLOG,
  FETCH_HUBBLOG,
  GET_VIEW_DATA,
  UPLOAD_MEDIA,
} from "./constants";

export function* fetchHubBlogSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company-blog?${query}`);
    yield put(fetchHubBlogSuccess(data));
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(fetchHubBlogFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/company-blog/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addHubBlogSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-blog/add`,
      payload?.data
    );

    if (data) {
      yield put(successAlert("Blog added successfully!"));
      yield put(addHubBlogSuccess());
      if (payload?.history) {
        payload.history.goBack();
      }
    }
  } catch (e) {
    yield put(addHubBlogFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editHubBlogSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-blog/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Blog updated successfully!"));
      yield put(editHubBlogSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editHubBlogFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteHubBlogSaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/company-blog/${payload}`);
    if (data) {
      yield put(successAlert("Blog deleted successfully!"));
      yield put(deleteHubBlogSuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteHubBlogFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* uploadMediaSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/blog-files/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Media updated successfully!"));
      yield put(uploadMediaSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(uploadMediaFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchHubBlogFlow() {
  yield takeEvery(FETCH_HUBBLOG, fetchHubBlogSaga);
}
export function* addHubBlogFlow() {
  yield takeEvery(ADD_HUBBLOG, addHubBlogSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* editHubBlogFlow() {
  yield takeEvery(EDIT_HUBBLOG, editHubBlogSaga);
}
export function* deleteHubBlogFlow() {
  yield takeEvery(DELETE_HUBBLOG, deleteHubBlogSaga);
}
export function* uploadMediaFlow() {
  yield takeEvery(UPLOAD_MEDIA, uploadMediaSaga);
}

export default function* HubBlogSaga() {
  yield all([
    fetchHubBlogFlow(),
    addHubBlogFlow(),
    getViewDataFlow(),
    editHubBlogFlow(),
    deleteHubBlogFlow(),
    uploadMediaFlow(),
  ]);
}
